export default __webpack_public_path__ + "static/media/animation.1bd04901.png";